<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            {{ cameraName }}
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container
        :style="{ overflow: hidden }"
        class="content video-monitor"
      >
        <!-- <zj-camera-preview
          :style="{ height:'100%',width:'100%',overflow: hidden}"
          :cameraId="cameraId"
          :cameraName="cameraName"
          :autoplay="autoplay"
          :cameraIsOnline="cameraIsOnline"
        /> -->
        <flv-player-real-time-new
          :style="{ height: '100%', width: '100%', overflow: hidden }"
          :cameraId="cameraId"
          :cameraName="cameraName"
          :currentIndex="currentIndex"
          :item="item"
          viewMode="swiper"
        />
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "ZJEmergencyComponentVideoGrow",
  componentName: "ZJEmergencyComponentVideoGrow",
  props: {
    cameraId: String,
    currentIndex:Number,
    cameraName: String,
    autoplay: {
      type: Boolean,
      default: false,
    },
    cameraIsOnline: {
      type: Boolean,
      default: false,
    },
    item:{
      type: Object,
      default: () => {},
    }
  },
  methods: {
    onBack: function () {
      this.$emit("handlerclose");
    },
  },
};
</script>